import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">{contactContent.title}</h2>
          <p className="text-sm md:text-base text-foreground-600">{contactContent.description}</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="flex flex-col items-center text-center p-4 rounded-xl bg-background-100 border border-background-200/60">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-primary-500 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">电子邮箱</span>
              <span className="text-sm text-foreground-700 font-medium break-all">{contactContent.email}</span>
            </div>
            <div className="flex flex-col items-center text-center p-4 rounded-xl bg-background-100 border border-background-200/60">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-qq-line text-accent-500 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">QQ群号</span>
              <span className="text-sm text-foreground-700 font-medium">{contactContent.qq}</span>
            </div>
            <div className="flex flex-col items-center text-center p-4 rounded-xl bg-background-100 border border-background-200/60">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-wechat-line text-secondary-500 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">微信公众号</span>
              <span className="text-sm text-foreground-700 font-medium">{contactContent.wechat}</span>
            </div>
          </div>
          <p className="text-center text-xs text-foreground-400 mt-5">{contactContent.hours}</p>
        </div>
      </div>
    </section>
  );
}